/**
 * Treasury and bank financial-control ids (ALC-4590), in catalog order. Only the treasury domain
 * edits this file. TR07–TR08 (debt schedules and covenants) are out of this slice.
 */
export const TR_FINANCIAL_CONTROL_IDS = ['TR01', 'TR02', 'TR03', 'TR04', 'TR05', 'TR06'] as const;
